import axios from 'axios'

axios.defaults.headers.common.Accept = 'application/json'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// TODO : move this key to an env files
axios.defaults.headers.common['X-Client-Secret'] = 'a754b3065993a8f280ba6900c5e902e68d240a806c2558c30429176da5098c40bf4ae4174fe93131e607d383722ab3036318866630db6d92b2a0ca22280d9b84'
